import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReferenceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
